import cache from '../../js/utilities/cache'

const enable = () => {
  // Hide footer bar
  const barHeight = 50
  const winHeight = cache.$window.outerHeight()
  const winPosBottom = cache.$window.scrollTop() + winHeight
  const mainHeight = cache.$main.outerHeight()

  if (winPosBottom >= mainHeight + barHeight) {
    cache.$main.addClass('hide-bottom-border')
  } else {
    cache.$main.removeClass('hide-bottom-border')
  }
}

export default { enable }
